import { Component, Inject, NgModule } from '@angular/core';
import { SiteBrowserState } from '../../core/util/site-browser.state';
import { FileSearchService } from '../../core/file/file-search.service';
import { CommonModule } from '@angular/common';
import { BreadcrumbModule, DialogModule } from 'primeng/primeng';
import { DotSiteSelectorModule } from '../site-selector/site-selector.component';
/**
 * The BreadcrumbComponent provides a PrimeNG Component for providing navigation with dotCMS Components
 * It can respond to the Site or Folder being changed.  In addition the navigation it provides can be clicked on
 * There is no connection to the other components directly.  The interaction is all managed by the [[SiteBrowserState]]
 * Unlike the breadcrumb component this component has a built in site selector
 */
var BreadcrumbHostselectorComponent = (function () {
    function BreadcrumbHostselectorComponent(updateService, fileSearchService) {
        var _this = this;
        this.updateService = updateService;
        this.fileSearchService = fileSearchService;
        this.homeItem = { label: 'Host Select', command: function (event) { _this.openHostSelectDialog(); } };
        this.buildMenuItemsFromURI(this.updateService.getURI());
        updateService.currentSite.subscribe(function (site) {
            _this.onSiteChange(site);
        });
        updateService.currentFolder.subscribe(function (folderName) {
            _this.onFolderClick(folderName);
        });
        updateService.currentURI.subscribe(function (uri) {
            _this.buildMenuItemsFromURI(uri);
        });
    }
    BreadcrumbHostselectorComponent.prototype.openHostSelectDialog = function () {
        this.hostDialog = true;
    };
    BreadcrumbHostselectorComponent.prototype.closeHostSelect = function () {
        this.hostDialog = false;
    };
    /**
     * Called when the [[SiteBrowserState]] Site is changed. This is managed via a Subscription
     * @param siteName
     */
    BreadcrumbHostselectorComponent.prototype.onSiteChange = function (site) {
        this.pathItems = [];
        this.addSiteItem(site);
        this.closeHostSelect();
    };
    /**
     * Called when the [[SiteBrowserState]] Folder is changed. This is managed via a Subscription
     * @param folderName
     */
    BreadcrumbHostselectorComponent.prototype.onFolderClick = function (folderName) {
        if (!folderName) {
            return;
        }
        var uri = this.getCurrentURI() + '/' + folderName;
        this.addFolderItem(folderName);
    };
    BreadcrumbHostselectorComponent.prototype.getCurrentURI = function () {
        var uri = '';
        for (var i = 1; i < this.pathItems.length; i++) {
            var pi = this.pathItems[i];
            uri = uri + '/' + pi.label;
        }
        return uri;
    };
    BreadcrumbHostselectorComponent.prototype.addSiteItem = function (site) {
        var _this = this;
        this.pathItems.push({
            command: function (event) {
                _this.updateService.changeSite(site);
                _this.updateService.changeURI(null);
                _this.updateService.changeFolder(null);
                _this.fileSearchService.changeSearchQuery(null);
                setTimeout(function () {
                }, 100);
            }, label: site ? site.hostname : ''
        });
    };
    BreadcrumbHostselectorComponent.prototype.addFolderItem = function (folderName) {
        var _this = this;
        var currentURI = this.getCurrentURI();
        this.pathItems.push({
            command: function (event) {
                _this.updateService.changeURI(currentURI + '/' + folderName);
                setTimeout(function () {
                }, 100);
            }, label: folderName
        });
    };
    BreadcrumbHostselectorComponent.prototype.buildMenuItemsFromURI = function (uri) {
        this.pathItems = [];
        var site = this.updateService.getSelectedSite();
        if (!site || !site.hostname) {
            return;
        }
        this.addSiteItem(site);
        if (uri) {
            var folders = uri.split('/');
            for (var i = 0; i < folders.length; i++) {
                this.onFolderClick(folders[i]);
            }
        }
    };
    return BreadcrumbHostselectorComponent;
}());
export { BreadcrumbHostselectorComponent };
BreadcrumbHostselectorComponent.decorators = [
    { type: Component, args: [{
                selector: 'app-breadcrumb-hostselector',
                template: "<p-breadcrumb [home]=\"homeItem\" [model]=\"pathItems\"></p-breadcrumb>\n    <p-dialog header=\"Select Host\" [contentStyle]=\"{'overflow':'visible'}\" [closable]=\"true\" [(visible)]=\"hostDialog\" [responsive]=\"true\" showEffect=\"fade\" [modal]=\"true\" (onAfterHide)=\"closeHostSelect()\" width=\"500\">\n      <site-selector></site-selector>\n    </p-dialog>"
            },] },
    { type: Inject, args: ['updateService',] },
];
/** @nocollapse */
BreadcrumbHostselectorComponent.ctorParameters = function () { return [
    { type: SiteBrowserState, },
    { type: FileSearchService, },
]; };
var DotBreadcrumbHostselectorModule = (function () {
    function DotBreadcrumbHostselectorModule() {
    }
    return DotBreadcrumbHostselectorModule;
}());
export { DotBreadcrumbHostselectorModule };
DotBreadcrumbHostselectorModule.decorators = [
    { type: NgModule, args: [{
                declarations: [BreadcrumbHostselectorComponent],
                exports: [BreadcrumbHostselectorComponent],
                imports: [CommonModule, BreadcrumbModule, DialogModule, DotSiteSelectorModule],
                providers: []
            },] },
];
/** @nocollapse */
DotBreadcrumbHostselectorModule.ctorParameters = function () { return []; };
//# sourceMappingURL=breadcrumb-hostselector.component.js.map